import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// API service functions
export const apiService = {
  // Statistics
  getStats: async () => {
    const response = await axios.get(`${API}/stats`);
    return response.data;
  },

  // Contact inquiries
  createContactInquiry: async (inquiryData) => {
    const response = await axios.post(`${API}/contact`, inquiryData);
    return response.data;
  },

  getContacts: async () => {
    const response = await axios.get(`${API}/contact`);
    return response.data;
  },

  // Newsletter subscription
  subscribeNewsletter: async (email) => {
    const response = await axios.post(`${API}/newsletter`, { email });
    return response.data;
  },

  getNewsletters: async () => {
    const response = await axios.get(`${API}/newsletter`);
    return response.data;
  },

  // Email response
  sendEmailResponse: async (contactId, message) => {
    const response = await axios.post(`${API}/send-email`, {
      contact_id: contactId,
      message: message
    });
    return response.data;
  },

  // Admin functions
  updateContactStatus: async (contactId, status) => {
    const response = await axios.put(`${API}/contact/${contactId}/status`, { status });
    return response.data;
  },

  // Test endpoint
  testConnection: async () => {
    const response = await axios.get(`${API}/`);
    return response.data;
  }
};

export default apiService;